// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from 'react-helmet';
import { useTranslation } from "react-i18next";
import he from "he";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID, appConfig } from "../../config/appConfig";

// COMPONENTI
import SubHeaderHome from "../Header/subHeader/SubHeaderHome";
import PropertySearchField from "./Search";
//import ServicesSection from "./ServicesSection";
import Vetrina1 from "./Vetrina1";
import Vetrina2 from "./Vetrina2";
import FooterBannerVendi from "./FooterBannerVendi";
import LocationSearch from "./LocationSearch";
import Presentation from "./Presentation";
import SocialPost from "./SocialPost";
import GoogleReviews from '../Reviews/GoogleReviews';
import HomeValuation from "./HomeValuation/HomeValuation";
// import TipologySearchSection from "./TipologySearchSection";
// import LastArticles from "./LastArticles";
// import NewsLetterSection from "./NewsLetterSection";
// import BannerVendi from "./BannerVendi";
// import ServicesSection2 from "./ServicesSection2";
// import LastProperties from "./LastProperties";
import BannerVendi from "./BannerVendi";
import ServicesSection2 from "./ServicesSection2";

interface Props {
    seo: boolean;
    vetrina2: boolean;
    pageType: string;
    filters: { [key: string]: string[] };
    showLocationSearch: boolean;
    showFooterBannerVendi: boolean;
    showPresentationSection: boolean;
    showSocialSection: boolean;
    showVetrina1: boolean;
    isLoaderFinished: boolean;
}

const HomePage: React.FC<Props> = ({
    seo,
    vetrina2,
    pageType,
    showLocationSearch,
    showFooterBannerVendi,
    showPresentationSection,
    showSocialSection,
    showVetrina1,
    isLoaderFinished
}) => {

    const { t } = useTranslation();
    const { agency } = useGetAgencyDetails(AGENCY_ID);

    // --- Lettura Flag Indipendenti dalla Configurazione ---
    const shouldShowInSubHeader = appConfig.ui.searchForm.showSearchInHomePageSubHeader;
    const shouldShowBelowIntro = appConfig.ui.searchForm.showSearchBelowHomePageIntro;
    const shouldShowSearchAndFiltersSection = appConfig.ui.homePage.showSearchAndFilters;
    const homeValuationConfig = appConfig.features.homeValuation;
    // --- Fine Lettura ---

    const isSeo = pageType === 'home';

    return (
        <>
            <Helmet>
                <title>{he.decode(`${agency?.agencyName}`) ?? t('common.loading')}</title>
            </Helmet>

            <SubHeaderHome
                isSeo={isSeo}
                showSearchForm={shouldShowInSubHeader}
                isLoaderFinished={isLoaderFinished}
            />

            {shouldShowSearchAndFiltersSection && pageType === 'home' &&(
                <section id="search-box" className="position-relative space-ptb">
                    <div className="container-fluid w-90">
                        <h2 className="text-center" dangerouslySetInnerHTML={{ __html: t('homePage.searchForm.title') as string }} />
                        <div className="row">
                            <div className="col-12">
                                {shouldShowBelowIntro && <PropertySearchField searchData={{}} />}
                            </div>
                        </div>
                    </div>
                </section>
            )}

            {/* Vetrina con immobili */}
            {vetrina2 && (
                <Vetrina2 agencyName={agency?.agencyName ?? ''} />
            )}

            {showPresentationSection && (
                <Presentation />
            )}

            {/* Banner Vendi */}
            <BannerVendi />

            {/* Social section */}
            {showSocialSection && <SocialPost />}

            {/* Anteprima servizi */}
            {appConfig.ui.homePage.showServices && (
                <ServicesSection2 />
            )}

            { /* Ricerca per tipologia
            <TipologySearchSection />
            */ }

            {/* Sezione Google Reviews */}
            {appConfig.features.googleReviews.enabled && (
                <>
                    <section id="google-reviews-box" className="space-ptb bg-gray">
                        <div className="container-fluid">
                            <GoogleReviews />
                        </div>
                    </section>
                    <div className="line-bar"></div>
                </>
            )}

            {/* NewsLetter Section }
            <NewsLetterSection />
            */ }

            {/* Ultimi articoli del blog
            <LastArticles />
            */}
            
            {/* Ricerca veloce con immagini */}
            {showLocationSearch && <LocationSearch seo={seo} />}

            {/* Ultimi aggiunti
            {<LastProperties />}
            */}

            {/* Seconda Anteprima servizi
            <ServicesSection2 />
            */}

            {/* Footer Banner Vendi */}
            {showFooterBannerVendi && <FooterBannerVendi />}

            {/* Vetrina con immobili */}
            {showVetrina1 && <Vetrina1 />}

            {homeValuationConfig.enabled && homeValuationConfig.displayMode === 'banner' && (
                <section className="space-ptb bg-light">
                    <div className="container">
                        <HomeValuation />
                    </div>
                </section>
            )}
        </>
    );
};

export default HomePage;